import { washProductListItem } from '@/utils/wash.js'
import { washDataArabic, washDataArabicAlign, ArabicEach } from '@/mm/utils.js'
import { createMuiltLanguagesJson } from "@/components/widgets/nav/repeatNumber.js";

export function washData_indexCase(walkedNode){
  if(walkedNode._type === 'index_case1'){
    if(
      walkedNode.list &&
      walkedNode.list[0] &&
      walkedNode.list[0].list &&
      walkedNode.list[0].list[0] &&
      walkedNode.list[0].list[0].list &&
      walkedNode.list[0].list[0].list[2] &&
      walkedNode.list[0].list[0].list[2].componentName === 'button_text'
    ){
      var buttonNode = walkedNode.list[0].list[0].list[2]
      buttonNode.actions = [
        "design",
        "hover",
        "translate"
      ]
    }
    let ArabicRule = [
      {
        flag: 'name',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'abstract',
        dataType: ['design','design'],
        onlyEnglish: ['title_textAlign',false],
        englishTitleLeft: ['left','self_paddingLeft'],
        englishTitleRight: ['right','self_paddingRight'],
      }
    ]
    ArabicEach(walkedNode, ArabicRule)
  }
  else if(walkedNode._type === 'index_case2'){
    if(
      walkedNode.list &&
      walkedNode.list[0] &&
      walkedNode.list[0].list &&
      walkedNode.list[0].list[1] &&
      walkedNode.list[0].list[1].list &&
      walkedNode.list[0].list[1].list[2] &&
      walkedNode.list[0].list[1].list[2].componentName === 'button_text'
    ){
      var buttonNode = walkedNode.list[0].list[1].list[2]
      buttonNode.actions = [
        {
          name: 'design',
          groupLayout: 'topBottom',
          config: {
            文字设计: [
              'self_fontFamily',
              'self_textTheme',
              'self_upperLowerCase',
              'self_fontSize',
              'self_color',
              'self_textStyle',
              'self_textAlign',
              'self_textInput'
            ],
            按钮设计: [
              'self_background',
              'self_border',
              'self_margin',
              'self_padding',
              'self_borderRadius',
              'self_transverseMargin',
              'self_shadow'
            ]
          }
        },
        'hover',
        'translate'
      ]
    }
    let ArabicRule = [
      {
        flag: 'name',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'abstract',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'more',
        dataType: ['design'],
        onlyEnglish: ['self_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      }
    ]
    ArabicEach(walkedNode, ArabicRule)
  }else if(walkedNode._type === 'index_case3'){
    let ArabicRule = [
      {
        flag: 'name',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'abstract',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      }
    ]
    ArabicEach(walkedNode, ArabicRule)
  } else if (walkedNode._type === 'index_case4') {
    washProductListItem(walkedNode, 'item', '4')
    let ArabicRule = [
      {
        flag: 'name',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'abstract',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      }
    ]
    ArabicEach(walkedNode, ArabicRule)
  }
  else if(walkedNode._type === 'index_case3'){
    getNodeByFlag(walkedNode,'abstract').forceShowEye = true
  }
  else if(walkedNode._type === 'index_case4'){
    getNodeByFlag(walkedNode,'abstract').forceShowEye = true
  }
  else if(walkedNode._type === 'index_case5'){
    if(
      walkedNode.list &&
      walkedNode.list[0] &&
      walkedNode.list[0].list &&
      walkedNode.list[0].list[3] &&
      walkedNode.list[0].list[3].componentName === 'button_text'
    ){
      var buttonNode = walkedNode.list[0].list[3]
      buttonNode.actions = [
        {
          "name": "design",
          "groupLayout": "topBottom",
          "config": {
            "文字设计": [
              "self_fontFamily",
              "self_textTheme",
              "self_fontSize",
              "self_color",
              "self_textStyle",
              "self_textAlign",
              "self_textInput"
            ],
            "按钮设计": [
              "self_background",
              "self_border",
              "self_borderRadius",
              "self_shadow",
              "self_padding",
              "self_margin"
            ]
          }
        },
        "hover",
        "translate"
      ]
    }
    let ArabicRule = [
      {
        flag: 'name',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'abstract',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'more',
        dataType: ['design','design'],
        onlyEnglish: ['self_textAlign',false],
        englishTitleLeft: ['left','self_paddingLeft'],
        englishTitleRight: ['right','self_paddingRight'],
      }
    ]
    ArabicEach(walkedNode, ArabicRule)
  }
  else if(walkedNode._type === 'index_case6'){
    if(
      walkedNode.list &&
      walkedNode.list[0] &&
      walkedNode.list[0].list &&
      walkedNode.list[0].list[1] &&
      walkedNode.list[0].list[1].list &&
      walkedNode.list[0].list[1].list[2] &&
      walkedNode.list[0].list[1].list[2].componentName === 'button_text'
    ){
      var buttonNode = walkedNode.list[0].list[1].list[2]
      buttonNode.actions = [
        "design",
        "hover",
        "translate"
      ]
    }
    let ArabicRule = [
      {
        flag: 'name',
        dataType: ['design','design'],
        onlyEnglish: ['title_textAlign',false],
        englishTitleLeft: ['left','self_marginLeft'],
        englishTitleRight: ['right','self_marginRight'],
      },
      {
        flag: 'abstract',
        dataType: ['design','design'],
        onlyEnglish: ['title_textAlign',false],
        englishTitleLeft: ['left','self_marginLeft'],
        englishTitleRight: ['right','self_marginRight'],
      },
      {
        flag: 'more',
        dataType: ['design'],
        onlyEnglish: [false],
        englishTitleLeft: ['self_marginLeft'],
        englishTitleRight: ['self_marginRight'],
      }
    ]
    ArabicEach(walkedNode, ArabicRule)
  }
  else if(walkedNode._type === 'index_case_style2'){
    let ArabicRule = [
      {
        flag: 'name',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'abstract',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      }
    ]
    ArabicEach(walkedNode, ArabicRule)
    if(walkedNode.editStyle){
      ArabicRule.forEach((item,index)=>{
        console.log(walkedNode.editStyle[item.flag][item.dataType][item.onlyEnglish])
        if(typeof walkedNode.editStyle[item.flag][item.dataType][item.onlyEnglish].diannao ==='object')return
        walkedNode.editStyle[item.flag][item.dataType][item.onlyEnglish] = {
          diannao:createMuiltLanguagesJson(item.englishTitleLeft,{'rtl': item.englishTitleRight}),
          pingban:createMuiltLanguagesJson(item.englishTitleLeft,{'rtl': item.englishTitleRight}),
          shouji:createMuiltLanguagesJson(item.englishTitleLeft,{'rtl': item.englishTitleRight})
        }
      })
    }
  }
}